import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup } from 'react-bootstrap';
import { faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';//faSearch


export function DeleteWarningModal(props) {

    //alert(JSON.stringify(props))
    const [confirmDeleteName, setConfirmDeleteName] = useState("");

    const componentName = props.modalTitle !== undefined ? `${props.modalTitle}` : `${props.component}`;
    let deleteMsgTitle = `You are about to delete a ${componentName}`;
    let deleteMsgContent = `This will delete your ${componentName}`;
    if (props.component === "configuredDatasourcesAdvanced" && props.datasourceDetails !== undefined) {
        deleteMsgTitle = `You are about to delete a datasource`;
        deleteMsgContent = `This will delete your configured dataSources: ${props.datasourceDetails.datasource_name} . This action cannot be undone. Are you sure you want to proceed?`;

         return (
        <Modal show={props.delete_show} centered onHide={props.deleteClose}>
            <Modal.Header closeButton className="d-none">
                <h5 className="modal-title" id="deleteWarningModal">
                    {`Delete ${componentName}`}</h5>
            </Modal.Header>
            <Modal.Body>
                <div className="modal__alert">
                    <div className="modal_alert-icon">
                        <i className="text-danger">
                            <FontAwesomeIcon icon={faTrashAlt}/>
                        </i>
                    </div>

                                    <div className="confirmation-alert_text">
                                        <h4>{`Delete Datasource`}</h4>
                                        <p>
                                          Please confirm the name of the datasource to delete:{" "}
                                          <strong>{props.datasourceDetails.datasource_name || "My_Deployment"}</strong>
                                        </p>
                                      </div>

                                                                  <div className="confirmation-alert_form">
                                                                    <Form.Group controlId="watchlist-name" className='mx-auto' style={{width: '85%'}}>
                                                                    {/* <Form.Label>
                                                                          Deployment Name <span style={{ color: "red" }}>*</span>
                                                                        </Form.Label> */}
                                                                      <InputGroup bsPrefix="icon-input-group">
                                                                        <Form.Control
                                                                          type="text"
                                                                          placeholder="Enter datasource name to confirm"
                                                                          className="mb-3 text-center pl-3 font-weight-medium"
                                                                          value={confirmDeleteName}
                                                                          onChange={(e) => setConfirmDeleteName(e.target.value)}

                                                                        />
                                                                      </InputGroup>
                                                                    </Form.Group>
                                                                    {/* {this.state.errors && (
                                                                      <div className="alert alert-danger text-left">
                                                                        <i className="text-danger mr-2">
                                                                          <FontAwesomeIcon icon={faExclamationTriangle} />
                                                                        </i>
                                                                        {this.state.errors}
                                                                      </div>
                                                                    )} */}
                                                                    <div className="alert alert-danger text-left">
                                                                      <i className="text-danger mr-2">
                                                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                                                      </i>
                                                                        Deleting this data source is permanent and cannot be undone. All associated integrations will also be deleted.
                                                                    </div>
                                                                  </div>

                    {/* <div className="modal_alert-text">
                        <h4>{deleteMsgTitle}</h4>
                        <p>{deleteMsgContent}</p>
                    </div> */}
                    <div className="modal_alert-btn-group">
                        <button type="button" onClick={props.deleteClose}
                                className="btn btn-outline btn-grey btn-circle mr-2">Cancel
                        </button>
                        <button type="button"
                                onClick={props.handleDeleteFunction}
                              //  disabled={props.disableDelete}
                                disabled={confirmDeleteName !== props.datasourceDetails.datasource_name}
                                className="btn btn-primary btn-circle mr-2">Delete
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )

    }
    else if (props.component === "Datasource" && props.datasourceDetails !== undefined) {
        // deleteMsgTitle = `You are about to delete a datasource`;
        // deleteMsgContent = `This will delete your configured dataSources: ${props.datasourceDetails.datasource_name} . This action cannot be undone. Are you sure you want to proceed?`;
            // console.log(props)
         return (
        <Modal show={props.delete_show} centered onHide={props.deleteClose}>
            <Modal.Header closeButton className="d-none">
                <h5 className="modal-title" id="deleteWarningModal">
                    {`Delete ${componentName}`}</h5>
            </Modal.Header>
            <Modal.Body>
                <div className="modal__alert">
                    <div className="modal_alert-icon">
                        <i className="text-danger">
                            <FontAwesomeIcon icon={faTrashAlt}/>
                        </i>
                    </div>

                                    <div className="confirmation-alert_text">
                                        <h4>{`Delete Integration`}</h4>
                                        <p>
                                          Please confirm the name of the integration to delete:{" "}
                                          <strong>{props.datasourceDetails.integration_name || "My_Deployment"}</strong>
                                        </p>
                                      </div>

                                                                  <div className="confirmation-alert_form">
                                                                    <Form.Group controlId="watchlist-name" className='mx-auto' style={{width: '85%'}}>
                                                                    {/* <Form.Label>
                                                                          Deployment Name <span style={{ color: "red" }}>*</span>
                                                                        </Form.Label> */}
                                                                      <InputGroup bsPrefix="icon-input-group">
                                                                        <Form.Control
                                                                          type="text"
                                                                          placeholder="Enter integration name to confirm"
                                                                          className="mb-3 text-center pl-3 font-weight-medium"
                                                                        value={confirmDeleteName}
                                                                          onChange={(e) => setConfirmDeleteName(e.target.value)}
                                                                        />
                                                                      </InputGroup>
                                                                    </Form.Group>
                                                                    {/* {this.state.errors && (
                                                                      <div className="alert alert-danger text-left">
                                                                        <i className="text-danger mr-2">
                                                                          <FontAwesomeIcon icon={faExclamationTriangle} />
                                                                        </i>
                                                                        {this.state.errors}
                                                                      </div>
                                                                    )} */}
                                                                    <div className="alert alert-danger text-left">
                                                                      <i className="text-danger mr-2">
                                                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                                                      </i>
                                                                      Deleting this Integration is permanent and cannot be undone.
                                                                    </div>
                                                                    {props.isLastIntegration && (
                                                                        <div className="alert alert-warning text-left">
                                                                            <i className="text-warning mr-2">
                                                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                                            </i>
                                                                            <strong>This is the only integration in the datasource.</strong> Deleting it will also permanently delete the parent datasource <strong>{props.datasourceDetails && props.datasourceDetails.datasource_name}</strong>.
                                                                        </div>
                                                                    )}
                                                                  </div>
{/* 
                    <div className="modal_alert-text">
                        <h4>{deleteMsgTitle}</h4>
                        <p>{deleteMsgContent}</p>
                    </div> */}
                    <div className="modal_alert-btn-group">
                        <button type="button" onClick={props.deleteClose}
                                className="btn btn-outline btn-grey btn-circle mr-2">Cancel
                        </button>
                        <button type="button"
                                onClick={props.handleDeleteFunction}
                                disabled={confirmDeleteName !== props.datasourceDetails.integration_name}
                                className="btn btn-primary btn-circle mr-2">Delete
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
    }
    else if (props.component === "configureCatalogue" && props.confirmName !== undefined) {
        const entityLabel = props.entityLabel || props.modalTitle || "item";
        const bulkCount = Number(props.bulkCount) || 0;
        const isBulk = bulkCount > 1;

        return (
            <Modal
                show={props.delete_show}
                centered
                onHide={() => {
                    setConfirmDeleteName("");
                    props.deleteClose();
                }}
            >
                <Modal.Header closeButton className="d-none">
                    <h5 className="modal-title" id="deleteWarningModal">
                        {isBulk ? `Delete ${bulkCount} items` : `Delete ${entityLabel}`}
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal__alert">
                        <div className="modal_alert-icon">
                            <i className="text-danger">
                                <FontAwesomeIcon icon={faTrashAlt}/>
                            </i>
                        </div>
                        <div className="confirmation-alert_text">
                            <h4>{isBulk ? `Delete ${bulkCount} items` : `Delete ${entityLabel}`}</h4>
                            <p>
                                {isBulk ? (
                                    <>
                                        You are about to permanently delete{" "}
                                        <strong>{bulkCount}</strong> selected items. Type{" "}
                                        <strong>{props.confirmName}</strong> to confirm.
                                    </>
                                ) : (
                                    <>
                                        Please confirm the name of the {entityLabel.toLowerCase()} to delete:{" "}
                                        <strong>{props.confirmName}</strong>
                                    </>
                                )}
                            </p>
                        </div>
                        <div className="confirmation-alert_form">
                            <Form.Group controlId="catalogue-delete-confirm-name" className='mx-auto' style={{width: '85%'}}>
                                <InputGroup bsPrefix="icon-input-group">
                                    <Form.Control
                                        type="text"
                                        placeholder={isBulk
                                            ? `Type ${props.confirmName} to confirm`
                                            : `Enter ${entityLabel.toLowerCase()} name to confirm`}
                                        className="mb-3 text-center pl-3 font-weight-medium"
                                        value={confirmDeleteName}
                                        onChange={(e) => setConfirmDeleteName(e.target.value)}
                                    />
                                </InputGroup>
                            </Form.Group>
                        </div>
                        <div className="modal_alert-btn-group">
                            <button
                                type="button"
                                onClick={() => {
                                    setConfirmDeleteName("");
                                    props.deleteClose();
                                }}
                                className="btn btn-outline btn-grey btn-circle mr-2"
                                disabled={props.deleting}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={props.handleDeleteFunction}
                                disabled={confirmDeleteName !== props.confirmName || props.deleting}
                                className="btn btn-primary btn-circle mr-2"
                            >
                                {props.deleting ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
    else if (
        (props.component === "Incremental Data Identifier" || props.component === "Partition") &&
        props.datasourceDetails !== undefined
    ) {
        const isIncremental = props.component === "Incremental Data Identifier";
        const isSpecifiedDataset = props.datasetScope === "specifiedDatasets";
        const confirmationName = isIncremental
            ? props.datasourceDetails.incremental_data_identifier_name || props.datasourceDetails.dataset_name
            : props.datasourceDetails.partition_name;
        const itemLabel = isIncremental ? "dataset" : "partition";
        const modalTitle = isIncremental
            ? (isSpecifiedDataset ? "Remove Dataset" : "Remove Incremental Data")
            : "Remove Partition";
        const warningMessage = isIncremental
            ? (isSpecifiedDataset
                ? "Deleting this Dataset is permanent and cannot be undone. All partitions associated with this dataset will also be deleted."
                : "Deleting this incremental data is permanent and cannot be undone.")
            : "Deleting this partition is permanent and cannot be undone.";

        return (
            <Modal show={props.delete_show} centered onHide={props.deleteClose}>
                <Modal.Header closeButton className="d-none">
                    <h5 className="modal-title" id="deleteWarningModal">
                        {`Remove ${props.component}`}
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal__alert">
                        <div className="modal_alert-icon">
                            <i className="text-danger">
                                <FontAwesomeIcon icon={faTrashAlt}/>
                            </i>
                        </div>
                        <div className="confirmation-alert_text">
                            <h4>{modalTitle}</h4>
                            <p>
                                Please confirm the name of the {itemLabel} to remove:{" "}
                                <strong>{confirmationName}</strong>
                            </p>
                        </div>
                        <div className="confirmation-alert_form">
                            <Form.Group controlId="remove-item-name" className="mx-auto" style={{width: '85%'}}>
                                <InputGroup bsPrefix="icon-input-group">
                                    <Form.Control
                                        type="text"
                                        placeholder={`Enter ${itemLabel} name to confirm`}
                                        className="mb-3 text-center pl-3 font-weight-medium"
                                        value={confirmDeleteName}
                                        onChange={(event) => setConfirmDeleteName(event.target.value)}
                                    />
                                </InputGroup>
                            </Form.Group>
                            <div className="alert alert-danger text-left">
                                <i className="text-danger mr-2">
                                    <FontAwesomeIcon icon={faExclamationTriangle} />
                                </i>
                                {warningMessage}
                            </div>
                        </div>
                        <div className="modal_alert-btn-group">
                            <button type="button" onClick={props.deleteClose}
                                    className="btn btn-outline btn-grey btn-circle mr-2">Cancel
                            </button>
                            <button type="button"
                                    onClick={props.handleDeleteFunction}
                                    disabled={confirmDeleteName !== confirmationName}
                                    className="btn btn-danger btn-circle mr-2">Remove
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
    else{
        return (
        <Modal show={props.delete_show} centered onHide={props.deleteClose}>
            <Modal.Header closeButton className="d-none">
                <h5 className="modal-title" id="deleteWarningModal">
                    {`Delete ${componentName}`}</h5>
            </Modal.Header>
            <Modal.Body>
                <div className="modal__alert">
                    <div className="modal_alert-icon">
                        <i className="text-danger">
                            <FontAwesomeIcon icon={faTrashAlt}/>
                        </i>
                    </div>
                    <div className="modal_alert-text">
                        <h4>{deleteMsgTitle}</h4>
                        <p>{deleteMsgContent}</p>
                    </div>
                    <div className="modal_alert-btn-group">
                        <button type="button" onClick={props.deleteClose}
                                className="btn btn-outline btn-grey btn-circle mr-2">Cancel
                        </button>
                        <button type="button"
                                onClick={props.handleDeleteFunction}
                                disabled={props.disableDelete}
                                className="btn btn-primary btn-circle mr-2">Delete
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
    }
    
}